// 管理员账号名称
export const ADMINISTRATOR_NAME = 'htadmin'
